import jwt_decode from "jwt-decode";
import { useAuth } from "./AuthProvider.js";

// Login: POST delle credenziali (il BE imposta il cookie di refresh), poi auth
// dal token. Restituisce { accessToken, decoded } (null senza token): la
// navigazione dopo il login la decide l'app. Gli errori arrivano al chiamante.
const useLogin = ({ api, loginUrl = "/auth/login" } = {}) => {
  const { setAuth } = useAuth();

  const login = async (payload) => {
    const response = await api.post(loginUrl, JSON.stringify(payload), {
      withCredentials: true,
    });
    const accessToken = response?.data?.accessToken;
    if (!accessToken) return null;

    const decoded = jwt_decode(accessToken);
    setAuth({
      username: payload.username,
      accessToken,
      role: decoded?.UserInfo?.role,
      global_roles: decoded?.UserInfo?.global_roles,
      // (rbac_roles can make the token gigantic, causing "400 Request Header Too Large")
      client_name: decoded?.UserInfo?.client_name,
      user_id: decoded?.UserInfo?.id || null,
      password_expire_date: decoded?.UserInfo?.password_expire_date,
      password_expiring: decoded?.UserInfo?.password_expiring ?? false,
    });
    return { accessToken, decoded };
  };

  return login;
};

export default useLogin;
